export const snackbarStyle = {
  maxHeight: 'none',
  height: 'auto',
  padding: '15px 24px',
  lineHeight: '1.4',
};
